import { render, staticRenderFns } from "./acompanhamentoexameslista.vue?vue&type=template&id=10a635dc&scoped=true&"
import script from "./acompanhamentoexameslista.vue?vue&type=script&lang=js&"
export * from "./acompanhamentoexameslista.vue?vue&type=script&lang=js&"
import style0 from "./acompanhamentoexameslista.vue?vue&type=style&index=0&id=10a635dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a635dc",
  null
  
)

export default component.exports